


/**
 * By default, zone.js will patch all possible macroTask and DomEvents
 * user can disable parts of macroTask/DomEvents patch by setting following flags
 */

 // (window as any).__Zone_disable_requestAnimationFrame = true; // disable patch requestAnimationFrame
 // (window as any).__Zone_disable_on_property = true; // disable patch onProperty such as onclick
 // (window as any).__zone_symbol__BLACK_LISTED_EVENTS = ['scroll', 'mousemove']; // disable patch specified eventNames

 /*
 * in IE/Edge developer tools, the addEventListener will also be wrapped by zone.js
 * with the following flag, it will bypass `zone.js` patch for IE/Edge
 */
// (window as any).__Zone_enable_cross_context_check = true;

/***************************************************************************************************
 * Zone JS is required by default for Angular itself.
 */
import 'zone.js';  // Included with Angular CLI.



/***************************************************************************************************
 * APPLICATION IMPORTS
 */

/**
 * Web Crypto API Polyfill
 * This polyfill provides a fallback for browsers that don't support the Web Crypto API
 * or have issues with the subtle.digest method used by MSAL for PKCE
 */
(function() {
  function applyPolyfill() {
    console.log('[Polyfill] Adding Web Crypto API polyfill for PKCE support');

    // Ensure window.crypto exists
    if (typeof window.crypto === 'undefined') {
      window.crypto = {} as Crypto;
    }

    // Ensure window.crypto.getRandomValues exists
    if (typeof window.crypto.getRandomValues !== 'function') {
      window.crypto.getRandomValues = function<T extends ArrayBufferView>(array: T): T {
        console.warn('[Polyfill] Using insecure fallback for crypto.getRandomValues');
        const typedArray = array as unknown as Uint8Array;
        const bytes = new Uint8Array(typedArray.length);
        for (let i = 0; i < bytes.length; i++) {
          bytes[i] = Math.floor(Math.random() * 256);
        }
        typedArray.set(bytes);
        return array;
      };
    }

    // Ensure window.crypto.subtle exists
    if (typeof window.crypto.subtle === 'undefined') {
      // Can't directly assign to read-only property, use Object.defineProperty instead
      Object.defineProperty(window.crypto, 'subtle', {
        value: {} as SubtleCrypto,
        configurable: true,
        enumerable: true
      });
    }

    // Ensure window.crypto.subtle.digest exists
    if (typeof window.crypto.subtle.digest !== 'function') {
      window.crypto.subtle.digest = function(algorithm: string | Algorithm, data: BufferSource): Promise<ArrayBuffer> {
        console.warn('[Polyfill] Using insecure fallback for crypto.subtle.digest');

        // Create a fixed-size hash (32 bytes for SHA-256) that's more consistent
        return new Promise((resolve) => {
          try {
            // Convert data to string
            let dataString = '';
            if (data instanceof ArrayBuffer) {
              dataString = new TextDecoder().decode(new Uint8Array(data));
            } else if (data instanceof Uint8Array) {
              dataString = new TextDecoder().decode(data);
            } else {
              // Try to handle other types of data
              const reader = new FileReader();
              reader.readAsText(new Blob([data as unknown as ArrayBuffer]));
              reader.onload = function() {
                const text = reader.result as string;

                // Generate a fixed-size 32-byte hash (SHA-256 size)
                const buffer = new ArrayBuffer(32); // 32 bytes for SHA-256
                const view = new Uint8Array(buffer);

                // Fill the buffer with a deterministic but simple hash
                // This is not cryptographically secure but will produce a consistent fixed-size output
                for (let i = 0; i < 32; i++) {
                  let value = 0;
                  for (let j = 0; j < text.length; j++) {
                    value = ((value << 5) - value + text.charCodeAt(j)) & 0xFF;
                    // Add position-dependent mixing to make the hash more unique
                    value = (value + (i * 13) + (j * 7)) & 0xFF;
                  }
                  view[i] = value;
                }

                resolve(buffer);
              };
              return;
            }

            // Generate a fixed-size 32-byte hash (SHA-256 size)
            const buffer = new ArrayBuffer(32); // 32 bytes for SHA-256
            const view = new Uint8Array(buffer);

            // Fill the buffer with a deterministic but simple hash
            // This is not cryptographically secure but will produce a consistent fixed-size output
            for (let i = 0; i < 32; i++) {
              let value = 0;
              for (let j = 0; j < dataString.length; j++) {
                value = ((value << 5) - value + dataString.charCodeAt(j)) & 0xFF;
                // Add position-dependent mixing to make the hash more unique
                value = (value + (i * 13) + (j * 7)) & 0xFF;
              }
              view[i] = value;
            }

            resolve(buffer);
          } catch (e) {
            console.error('[Polyfill] Error in digest polyfill:', e);
            // Return a default hash to prevent authentication from failing completely
            const defaultBuffer = new ArrayBuffer(32); // 32 bytes for SHA-256
            const defaultView = new Uint8Array(defaultBuffer);
            for (let i = 0; i < 32; i++) {
              defaultView[i] = i;
            }
            resolve(defaultBuffer);
          }
        });
      };
    }

    console.log('[Polyfill] Web Crypto API polyfill added successfully');
  }

  // More comprehensive check for Web Crypto API availability
  const needsPolyfill = (function() {
    // Check if window is defined (for SSR)
    if (typeof window === 'undefined') {
      return false;
    }

    // Check if crypto is available
    if (typeof window.crypto === 'undefined') {
      console.warn('[Polyfill] window.crypto is not available');
      return true;
    }

    // Check if subtle is available
    if (typeof window.crypto.subtle === 'undefined') {
      console.warn('[Polyfill] window.crypto.subtle is not available');
      return true;
    }

    // Check if digest function is available
    if (typeof window.crypto.subtle.digest !== 'function') {
      console.warn('[Polyfill] window.crypto.subtle.digest is not a function');
      return true;
    }

    // Try to actually use the digest function to see if it works
    try {
      // Create a simple test
      const testData = new TextEncoder().encode('test');
      window.crypto.subtle.digest('SHA-256', testData)
        .catch(e => {
          console.warn('[Polyfill] window.crypto.subtle.digest threw an error:', e);
          // If we get here, the function exists but doesn't work properly
          return true; // Signal that polyfill is needed
        });
      return false;
    } catch (e) {
      console.warn('[Polyfill] Error testing window.crypto.subtle.digest:', e);
      return true;
    }
  })();

  // Apply the polyfill if needed
  if (needsPolyfill) {
    applyPolyfill();
  } else {
    console.log('[Polyfill] Web Crypto API is fully available, no polyfill needed');
  }
})();
